import {
  initialState,
  Actions,
  State,
  GET_ONE_DISCOUNT,
  GET_ONE_DISCOUNT_SUCCESS,
  GET_ONE_DISCOUNT_ERROR,
  UPDATE_CURRENT_DISCOUNT,
  RESET_CURRENT_DISCOUNT
} from "../../types/discount/get-one-discount";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_DISCOUNT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ONE_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ONE_DISCOUNT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_DISCOUNT:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case RESET_CURRENT_DISCOUNT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
